import { render, staticRenderFns } from "./ed-file-to-split-object.vue?vue&type=template&id=6b0fd088&scoped=true&"
import script from "./ed-file-to-split-object.ts?vue&type=script&lang=ts&"
export * from "./ed-file-to-split-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-file-to-split-object.scss?vue&type=style&index=0&id=6b0fd088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0fd088",
  null
  
)

export default component.exports